import endpoints from "../../utils/endpoints";
import { publicAxios as axios } from "../../config/axios";
import globalConstant from "../../utils/constants";

export const getCarMakers = async () => {
  try {
    const response = await axios({
      method: globalConstant.GET,
      url: endpoints.getCarMakers(),
      headers: {
        Authorization: localStorage.getItem("auth_orca"),
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching car makers:", error);
    throw error;
  }
};

export const getModelLines = async (makerId: string) => {
  try {
    const response = await axios({
      method: globalConstant.GET,
      url: endpoints.getModelLines(makerId),
      headers: {
        Authorization: localStorage.getItem("auth_orca"),
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching model lines:", error);
    throw error;
  }
};

export const getCarYears = async (lineId: string, makerId: string) => {
  try {
    const response = await axios({
      method: globalConstant.GET,
      url: endpoints.getCarYears(lineId, makerId),
      headers: {
        Authorization: localStorage.getItem("auth_orca"),
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching car years:", error);
    throw error;
  }
};

export const getCarModifications = async (
  lineId: string,
  year: string,
  makerId: string
) => {
  try {
    const response = await axios({
      method: globalConstant.GET,
      url: endpoints.getCarModifications(lineId, year, makerId),
      headers: {
        Authorization: localStorage.getItem("auth_orca"),
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching car modifications:", error);
    throw error;
  }
};
